import * as React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { Collapse, makeStyles } from "@material-ui/core";
import { color } from "../../../helpers/constant";
import Restrict from "../../../helpers/Restrict";
import "./index.scss";

const useStyle = makeStyles(theme => ({
  navLink: {
    display: "flex",
    textDecoration: "none",
    color: color.darkGrey
  },
  navLinkActive: {
    color: color.primary
  },
  navLinkContainer: {
    display: "flex",
    width: "100%",
    alignItems: "center"
  }
}));

const NavigationTabsOptions = props => {
  const { componentList, prevComponent, depth = 0, depthStep = 20 } = props;

  const { t } = useTranslation();
  const classes = useStyle();

  const { children, component, text, icon } = componentList;

  const [tabs, setTabs] = React.useState(false);

  const toggleTabs = () => {
    setTabs(prevValue => !prevValue);
  };

  const onClickSubMenuTabs = () => {
    if (Array.isArray(children)) {
      toggleTabs();
    }
  };

  return (
    <>
      <ul className="menu-list-none-style">
        <li style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <div
            className="font-weight-button"
            style={{
              width: "100%",
              paddingLeft: 3 * 20 + "px",
              paddingRight: "15px",
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              fontSize: "14px"
            }}
            onClick={onClickSubMenuTabs}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                fontSize: "14px"
              }}
            >
              {component ? (
                component
              ) : (
                <div className={classes.navLinkContainer}>
                  <i className="material-icons  navigation-icon">{icon}</i>
                  <span>{t(text)}</span>
                </div>
              )}
            </div>
            <i className="arrow-up  material-icons">keyboard_arrow_right</i>
          </div>
        </li>
      </ul>
      <div
        className={
          tabs
            ? "navigation-menu-with-transform"
            : "navigation-menu-without-transform"
        }
      >
        <ul className="menu-list-none-style">
          <ul className="menu-list-none-style">
            <li
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                backgroundColor: "rgba(0, 0, 0, 0.08)"
              }}
            >
              <div
                className="font-weight-button"
                style={{
                  width: "100%",
                  paddingLeft: "17px",
                  paddingRight: "15px",
                  display: "flex",
                  cursor: "pointer",
                  fontSize: "14px"
                }}
                onClick={onClickSubMenuTabs}
              >
                <i
                  style={{ paddingRight: "10px" }}
                  className="arrow-up  material-icons"
                >
                  arrow_back
                </i>
                {prevComponent.component ? (
                  prevComponent.component
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%"
                    }}
                  >
                    <span>{t(prevComponent.text)}</span>
                  </div>
                )}
              </div>
            </li>
          </ul>

          {Array.isArray(children) ? (
            <>
              {children.map((subItem, index) => {
                return (
                  <React.Fragment key={index}>
                    {subItem.children && subItem.children.length > 0 ? (
                      <>
                        <Restrict permissions={subItem.permissions}>
                          <NavigationOptionsList
                            componentList={subItem}
                            depth={depth + 1}
                            depthStep={depthStep}
                            key={index}
                          />
                        </Restrict>
                      </>
                    ) : (
                      <>
                        <ul className="menu-list-none-style" key={index}>
                          <Restrict permissions={subItem.permissions}>
                            <li
                              style={{
                                paddingTop: "10px",
                                paddingBottom: "10px"
                              }}
                            >
                              <div
                                className="font-weight-button"
                                style={{
                                  width: "100%",
                                  paddingLeft: 1 * 20 + "px",
                                  paddingRight: "15px",
                                  display: "flex",
                                  cursor: "pointer",
                                  justifyContent: "space-between",
                                  fontSize: "14px"
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    fontSize: "14px"
                                  }}
                                >
                                  {subItem.component ? (
                                    subItem.component
                                  ) : (
                                    <>
                                      <NavLink
                                        to={subItem.link}
                                        activeClassName={classes.navLinkActive}
                                        className={classes.navLink}
                                      >
                                        <i className="material-icons navigation-icon">
                                          {subItem.icon}
                                        </i>
                                        <span>{t(subItem.text)}</span>
                                      </NavLink>
                                    </>
                                  )}
                                </div>
                              </div>
                            </li>
                          </Restrict>
                        </ul>
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </>
          ) : null}
        </ul>
      </div>
    </>
  );
};

const NavigationOptionsList = props => {
  const { componentList, depth = 0, depthStep = 20 } = props;

  const { t } = useTranslation();
  const classes = useStyle();

  const { component, children, text, icon } = componentList;
  const [collapsed, setCollapsed] = React.useState(true);

  const toggleCollapse = () => {
    setCollapsed(prevValue => !prevValue);
  };

  const onClickSubMenu = () => {
    if (Array.isArray(children)) {
      toggleCollapse();
    }
  };

  return (
    <>
      <ul className="menu-list-none-style">
        <li style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <div
            className={
              collapsed ? "font-weight-button" : "font-weight-button-bold"
            }
            style={{
              width: "100%",
              paddingLeft: depth * depthStep + "px",
              paddingRight: "15px",
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              fontSize: "14px"
            }}
            onClick={onClickSubMenu}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                fontSize: "14px"
              }}
            >
              {component ? (
                component
              ) : (
                <>
                  <div className={classes.navLinkContainer}>
                    <i className="material-icons navigation-icon">{icon}</i>
                    <span>{t(text)}</span>
                  </div>
                </>
              )}
            </div>
            <i className="arrow-up  material-icons">
              {collapsed ? "keyboard_arrow_down" : "keyboard_arrow_up"}
            </i>
          </div>
        </li>
        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          {Array.isArray(children) ? (
            <>
              {children.map((subItem, index) => {
                if (subItem.toNewTab) {
                  return (
                    <Restrict permissions={subItem.permissions}>
                      <NavigationTabsOptions
                        componentList={subItem}
                        prevComponent={subItem}
                        key={index}
                      />
                    </Restrict>
                  );
                } else if (subItem.children && subItem.children.length > 0) {
                  return (
                    <Restrict permissions={subItem.permissions}>
                      <NavigationOptionsList
                        depth={depth + 1}
                        depthStep={depthStep}
                        componentList={subItem}
                        key={index}
                      />
                    </Restrict>
                  );
                } else {
                  return (
                    <React.Fragment key={index}>
                      <Restrict permissions={subItem.permissions}>
                        <li
                          style={{
                            paddingTop: "10px",
                            paddingBottom: "10px"
                          }}
                          key={index}
                        >
                          <div
                            className="font-weight-button"
                            style={{
                              width: "100%",
                              justifyContent: "space-between",
                              paddingLeft: 2 * 20 + "px",
                              paddingRight: "15px",
                              display: "flex",
                              cursor: "pointer",
                              fontSize: "14px"
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                fontSize: "14px"
                              }}
                            >
                              {subItem.component ? (
                                subItem.component
                              ) : (
                                <>
                                  <NavLink
                                    to={subItem.link}
                                    activeClassName={classes.navLinkActive}
                                    className={classes.navLink}
                                  >
                                    <i className="material-icons navigation-icon">
                                      {subItem.icon}
                                    </i>
                                    <span>{t(subItem.text)}</span>
                                  </NavLink>
                                </>
                              )}
                            </div>
                          </div>
                        </li>
                      </Restrict>
                    </React.Fragment>
                  );
                }
              })}
            </>
          ) : null}
        </Collapse>
      </ul>
    </>
  );
};

const NavigationList = props => {
  const { items, depth = 0, depthStep = 20 } = props;

  const { t } = useTranslation();
  const classes = useStyle();

  return (
    <>
      <div className="sidenav-content">
        {items.map((sidebaritems, index) => {
          return (
            <React.Fragment key={index}>
              {sidebaritems.children && sidebaritems.children.length > 0 ? (
                <>
                  <Restrict permissions={sidebaritems.permissions}>
                    <NavigationOptionsList
                      depth={depth + 1}
                      depthStep={depthStep}
                      componentList={sidebaritems}
                      key={index}
                    />
                  </Restrict>
                </>
              ) : (
                <>
                  <ul className="menu-list-none-style" key={index}>
                    <Restrict permissions={sidebaritems.permissions}>
                      <li
                        style={{
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "20px",
                          paddingRight: "14px"
                        }}
                      >
                        <div
                          className="font-weight-button"
                          style={{
                            width: "100%",
                            display: "flex",
                            cursor: "pointer",
                            justifyContent: "space-between",
                            fontSize: "14px"
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              fontSize: "14px"
                            }}
                          >
                            {sidebaritems.component ? (
                              sidebaritems.component
                            ) : (
                              <>
                                <NavLink
                                  to={sidebaritems.link}
                                  activeClassName={classes.navLinkActive}
                                  className={classes.navLink}
                                >
                                  <i className="material-icons navigation-icon">
                                    {sidebaritems.icon}
                                  </i>
                                  <span>{t(sidebaritems.text)}</span>
                                </NavLink>
                              </>
                            )}
                          </div>
                        </div>
                      </li>
                    </Restrict>
                  </ul>
                </>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default NavigationList;
